import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DownloadedCheckmarkProps {
  className?: string;
}

export const DownloadedCheckmark = ({
  className,
}: DownloadedCheckmarkProps) => (
  <div
    className={cn(
      'flex size-6 items-center justify-center rounded-full bg-green-400',
      className,
    )}
  >
    <Check className="size-3.5 text-gray-800" strokeWidth={2.5} />
  </div>
);
